module.exports = __webpack_public_path__ + "img/inform-disable.b7e7a9b6.svg";